import type { PricingPrefs } from "../store/persistence";
import { ItineraryPricingPreferencesDTO } from "../types/dtos/api/pricing/itinerary-pricing-preferences.dto";

/**
 * Maps persisted UI pricing preferences to the backend itinerary pricing DTO.
 *
 * @param prefs Persisted pricing preferences from `pricingPrefsSlice`.
 * @returns DTO shape accepted by itinerary search and offer endpoints.
 */
export const toItineraryPricingPreferencesDTO = ( prefs: PricingPrefs ): ItineraryPricingPreferencesDTO => {
    const dto = new ItineraryPricingPreferencesDTO();
    dto.swissReductionCard = prefs.swissReductionCard;
    dto.useSuperSaverIfAvailable = prefs.swissSuperSaver;
    dto.categoryOfService = prefs.categoryOfService === "FIRST_CLASS" ? "1" : "2";

    return dto;
};
